// src/utils/heartConstants.js
export const MAX_HEARTS        = 5;
export const MINUTES_PER_HEART = 12;
export const MS_PER_HEART      = MINUTES_PER_HEART * 60 * 1000;
